import { Injectable } from "@angular/core";
import { VideoEvent } from "@core/models/videojs.model";
import { Observable } from "rxjs";
import { API_LIST } from "@core/services/web-api/api-list";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class VideojsService {

  constructor(private httpClient: HttpClient) {}

  postMediaEvent(mediaId: string, payload: VideoEvent) : Observable<Object> {
    return this.httpClient.post(API_LIST.postMediaEvent(mediaId), payload);
  }
}
